import { RIGOUR, RIGOUR_CHAIN, SECTION_IDS } from "./content";
import { Reveal } from "./reveal";

export const ScientificRigour = () => (
  <section
    id={SECTION_IDS.rigour}
    className="relative overflow-hidden border-t border-white/[.07] bg-ink-2 px-[clamp(16px,4vw,64px)] py-[clamp(96px,13vw,200px)]"
  >
    <div
      className="absolute inset-0 opacity-50"
      style={{
        backgroundImage:
          "linear-gradient(rgba(127,232,180,.07) 1px, transparent 1px), linear-gradient(90deg, rgba(127,232,180,.07) 1px, transparent 1px)",
        backgroundSize: "64px 64px",
      }}
    />

    <div className="dc-shell relative z-2">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,320px),1fr))] gap-[clamp(32px,5vw,96px)]">
        <div>
          <h2 className="mt-0 mb-7 text-[clamp(32px,4.4vw,72px)] font-bold leading-[.98] tracking-[-.04em] text-balance">
            Science you can check, in answers you can defend.
          </h2>
          <p className="mt-0 mb-10 max-w-[46ch] text-[17px] leading-[1.7] text-mist-2">
            Our data is used in compliance cases, valuations and public reports.
            The confidence you place in them is backed by science.
          </p>
          <div className="dc-mono flex flex-wrap items-center gap-2.5 text-[12px] uppercase tracking-[.16em] text-mist-4">
            {RIGOUR_CHAIN.map((link, index) => (
              <span key={link} className="inline-flex items-center gap-2.5">
                <span className="border-b border-mint/50 px-0.5 py-1.5 text-mint">
                  {link}
                </span>
                {index < RIGOUR_CHAIN.length - 1 ? <span>→</span> : null}
              </span>
            ))}
          </div>
        </div>

        <div className="grid">
          {RIGOUR.map((item, index) => (
            <Reveal
              key={item.num}
              delay={index * 80}
              className="grid grid-cols-[46px_minmax(0,1fr)] gap-5 border-t border-white/[.14] py-[26px]"
            >
              <div className="dc-mono text-[12px] text-mint">{item.num}</div>
              <div>
                <h3 className="mt-0 mb-2.5 text-[clamp(18px,1.6vw,22px)] font-semibold tracking-[-.018em]">
                  {item.title}
                </h3>
                <p className="m-0 text-[17px] leading-[1.7] text-mist-3">
                  {item.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
